import _JSXStyle from "styled-jsx/style";
import { Card } from '@dhis2-ui/card';
import { Center } from '@dhis2-ui/center';
import { Divider } from '@dhis2-ui/divider';
import { Layer } from '@dhis2-ui/layer';
import { CircularLoader } from '@dhis2-ui/loader';
import { MenuDivider, MenuItem } from '@dhis2-ui/menu';
import { clearSensitiveCaches, useConfig } from '@dhis2/app-runtime';
import { colors } from '@dhis2/ui-constants';
import { IconSettings24, IconInfo24, IconLogOut24, IconUser24, IconQuestion24 } from '@dhis2/ui-icons';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { DebugInfoMenuItem } from '../debug-info/debug-info-menu-item.js';
import { joinPath } from '../join-path.js';
import i18n from '../locales/index.js';
import { ProfileHeader } from './profile-header.js';
import { UpdateNotification } from './update-notification.js';

const LoadingMask = () => /*#__PURE__*/React.createElement(Layer, {
  translucent: true,
  disablePortal: true,
  dataTest: "headerbar-profile-menu-loading-mask"
}, /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(CircularLoader, null)));

const ProfileContents = _ref => {
  let {
    name,
    email,
    avatarId,
    helpUrl,
    hideProfileMenu,
    showDebugInfoModal
  } = _ref;
  const {
    baseUrl
  } = useConfig();
  const [loading, setLoading] = useState(false);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("div", {
    className: "jsx-2099675810"
  }, /*#__PURE__*/React.createElement(ProfileHeader, {
    name: name,
    email: email,
    avatarId: avatarId
  }), /*#__PURE__*/React.createElement(Divider, {
    margin: "13px 0 7px 0"
  }), /*#__PURE__*/React.createElement("ul", {
    "data-test": "headerbar-profile-menu",
    className: "jsx-2099675810"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    href: joinPath(baseUrl, 'dhis-web-user-profile/#/settings'),
    label: i18n.t('Settings'),
    value: "settings",
    icon: /*#__PURE__*/React.createElement(IconSettings24, {
      color: colors.grey700
    })
  }), /*#__PURE__*/React.createElement(MenuItem, {
    href: joinPath(baseUrl, 'dhis-web-user-profile/#/account'),
    label: i18n.t('Account'),
    value: "account",
    icon: /*#__PURE__*/React.createElement(IconUser24, {
      color: colors.grey700
    })
  }), helpUrl && /*#__PURE__*/React.createElement(MenuItem, {
    href: helpUrl,
    label: i18n.t('Help'),
    value: "help",
    icon: /*#__PURE__*/React.createElement(IconQuestion24, {
      color: colors.grey700
    })
  }), /*#__PURE__*/React.createElement(MenuItem, {
    href: joinPath(baseUrl, 'dhis-web-user-profile/#/aboutPage'),
    label: i18n.t('About DHIS2'),
    value: "about",
    icon: /*#__PURE__*/React.createElement(IconInfo24, {
      color: colors.grey700
    })
  }), /*#__PURE__*/React.createElement(MenuItem, {
    href: joinPath(baseUrl, 'dhis-web-commons-security/logout.action') // NB: By MenuItem implementation, this callback
    // overwrites default navigation behavior but maintains
    // the href attribute
    ,
    onClick: async () => {
      setLoading(true);
      await clearSensitiveCaches();
      setLoading(false);
      window.location.assign(joinPath(baseUrl, 'dhis-web-commons-security/logout.action'));
    },
    label: i18n.t('Logout'),
    value: "logout",
    icon: /*#__PURE__*/React.createElement(IconLogOut24, {
      color: colors.grey700
    })
  }), /*#__PURE__*/React.createElement(MenuDivider, {
    dense: true
  }), /*#__PURE__*/React.createElement(DebugInfoMenuItem, {
    hideProfileMenu: hideProfileMenu,
    showDebugInfoModal: showDebugInfoModal
  }), /*#__PURE__*/React.createElement(UpdateNotification, {
    hideProfileMenu: hideProfileMenu
  }))), loading && /*#__PURE__*/React.createElement(LoadingMask, null), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2099675810"
  }, ["div.jsx-2099675810{width:100%;padding:0;}", "ul.jsx-2099675810{padding:0;margin:0;}", "a.jsx-2099675810,a.jsx-2099675810:hover,a.jsx-2099675810:focus,a.jsx-2099675810:active,a.jsx-2099675810:visited{-webkit-text-decoration:none;text-decoration:none;display:block;}"]));
};

ProfileContents.propTypes = {
  hideProfileMenu: PropTypes.func.isRequired,
  showDebugInfoModal: PropTypes.func.isRequired,
  avatarId: PropTypes.string,
  email: PropTypes.string,
  helpUrl: PropTypes.string,
  name: PropTypes.string
};
export const ProfileMenu = _ref2 => {
  let { ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-profile-menu",
    className: "jsx-3924623997"
  }, /*#__PURE__*/React.createElement(ProfileContents, props), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3924623997"
  }, ["div.jsx-3924623997{z-index:10000;position:absolute;inset-inline-end:4px;width:320px;}"]));
};
ProfileMenu.propTypes = {
  hideProfileMenu: PropTypes.func.isRequired,
  showDebugInfoModal: PropTypes.func.isRequired,
  avatarId: PropTypes.string,
  email: PropTypes.string,
  helpUrl: PropTypes.string,
  name: PropTypes.string
};